import { defineMessages } from "@/i18n";
import en from "./en";

export const canvasCommentsMessages = defineMessages("canvas-comments", en);
